import { Button, Card, minWidth, Paragraph, SmallText } from 'hui';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Input = styled.input`
  display: block;
  border-radius: ${props => props.theme.radius.element};
  border: 1px solid ${props => props.theme.colors.tint3};
  padding: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
`;
const HiddenMobile = styled.div`
  display: none;

  ${minWidth('lg')} {
    display: block;
  }
`;

const ArticleSearch = ({ query = '' }) => (
  <Card>
    <Paragraph bold mb={0}>
      Search for articles
    </Paragraph>
    <SmallText>Find tips and advice for all around your home</SmallText>
    <form action="/articles" method="get">
      <input type="hidden" name="c" value="article_topics" />
      <Input name="q" placeholder="Search all articles" defaultValue={query} />
      <Button color="tint1" block>
        Search
      </Button>
    </form>

    <Link to="/c">
      <HiddenMobile>
        <SmallText align="center" mb={0} color="primary">
          Browse all topics
        </SmallText>
      </HiddenMobile>
    </Link>
  </Card>
);

ArticleSearch.propTypes = {
  query: PropTypes.string
};
export default ArticleSearch;
